import { createSelector } from '@ngrx/store';
import {
  getOneClickOrders,
  getOneClickSelectedOrder,
  getOneClickIsSelectedOrderFromTable,
  getOneClickResult,
} from './one-click-orders.selector';

export const oneClickOrdersTable = createSelector(
  getOneClickOrders,
  getOneClickSelectedOrder,
  getOneClickIsSelectedOrderFromTable,
  getOneClickResult,
  (orders, selectedOrder, isFromTable, result) => ({ orders, selectedOrder, isFromTable, result }),
);
